var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visitor-survey-element" },
    [
      _vm.element
        ? [
            _vm.element.type === _vm.TYPE_INPUT
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "checkout-form__field",
                      class: {
                        "form__field--error":
                          _vm.element.config.isRequired &&
                          !_vm.isValid &&
                          _vm.showErrors,
                      },
                    },
                    [
                      _c(
                        "label",
                        { attrs: { for: _vm.element.id } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.element.config.question) +
                              "\n          "
                          ),
                          _vm.element.config.isRequired
                            ? [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("global.forms.required")) +
                                    "\n          "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim.lazy",
                            value: _vm.formData.answer,
                            expression: "formData.answer",
                            modifiers: { trim: true, lazy: true },
                          },
                        ],
                        attrs: {
                          id: _vm.element.event.id + "-" + _vm.element.id,
                          type: "text",
                        },
                        domProps: { value: _vm.formData.answer },
                        on: {
                          change: function ($event) {
                            _vm.$set(
                              _vm.formData,
                              "answer",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.element.type === _vm.TYPE_SELECT &&
            _vm.element.config.options.length > 0
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "checkout-form__field form__group form__group--select",
                      class: {
                        "form__field--error":
                          _vm.element.config.isRequired &&
                          !_vm.isValid &&
                          _vm.showErrors,
                      },
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "form__label form-question",
                          attrs: { for: _vm.element.id },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.element.config.question) +
                              "\n          "
                          ),
                          _vm.element.config.isRequired
                            ? [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("global.forms.required")) +
                                    "\n          "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form__selectWrapper icon icon-arrow-right",
                          class: {
                            "form__field--error":
                              _vm.element.config.isRequired &&
                              _vm.validateSurvey &&
                              !_vm.isValid,
                          },
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.formData.answer,
                                  expression: "formData.answer",
                                },
                              ],
                              staticClass: "form__select",
                              attrs: {
                                id: _vm.element.event.id + "-" + _vm.element.id,
                              },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.formData,
                                    "answer",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _vm._l(
                                _vm.element.config.options,
                                function (option, idx) {
                                  return [
                                    _c(
                                      "option",
                                      {
                                        key:
                                          _vm.element.event.id +
                                          "-" +
                                          _vm.element.id +
                                          "-" +
                                          idx,
                                        domProps: { value: option },
                                      },
                                      [_vm._v(_vm._s(option.value))]
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.element.config.isRequired &&
                  !_vm.isValid &&
                  _vm.validateSurvey
                    ? [
                        _c(
                          "div",
                          { staticClass: "form__field--error-infoText" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "checkout.personalisation.visitorSurvey.errorInfo"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ]
              : _vm.element.type === _vm.TYPE_SELECT
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("checkout.personalisation.visitorSurvey.error")
                      ) +
                      "\n    "
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.element.type === _vm.TYPE_RADIO &&
            _vm.element.config.options.length > 0
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "checkout-form__field form__group form__group--select",
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "form__label form-question",
                          attrs: {
                            for: _vm.element.event.id + "-" + _vm.element.id,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.element.config.question) +
                              "\n          "
                          ),
                          _vm.element.config.isRequired
                            ? [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("global.forms.required")) +
                                    "\n          "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "checkout-form__field checkout-form__field--radio",
                          class: {
                            "form__field--error":
                              _vm.validateSurvey && !_vm.isValid,
                          },
                        },
                        [
                          _vm._l(
                            _vm.element.config.options,
                            function (choice, idx) {
                              return [
                                _c(
                                  "label",
                                  {
                                    key:
                                      _vm.element.event.id +
                                      "-" +
                                      _vm.element.id +
                                      "-" +
                                      idx,
                                    attrs: {
                                      for:
                                        _vm.element.event.id +
                                        "-" +
                                        _vm.element.id +
                                        "-" +
                                        idx,
                                    },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.formData.answer,
                                          expression: "formData.answer",
                                        },
                                      ],
                                      staticClass:
                                        "checkout-form__field--radio-input form-answer",
                                      attrs: {
                                        id:
                                          _vm.element.event.id +
                                          "-" +
                                          _vm.element.id +
                                          "-" +
                                          idx,
                                        name:
                                          _vm.element.event.id +
                                          "-" +
                                          _vm.element.id,
                                        type: "radio",
                                      },
                                      domProps: {
                                        value: choice,
                                        checked: _vm._q(
                                          _vm.formData.answer,
                                          choice
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.$set(
                                            _vm.formData,
                                            "answer",
                                            choice
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass:
                                        "radio__checkMark radio__checkMark-surveyForm",
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(choice.value) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.element.config.isRequired &&
                  !_vm.isValid &&
                  _vm.validateSurvey
                    ? [
                        _c(
                          "div",
                          { staticClass: "form__field--error-infoText" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "checkout.personalisation.visitorSurvey.errorInfo"
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ]
              : _vm.element.type === _vm.TYPE_RADIO
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("checkout.personalisation.visitorSurvey.error")
                      ) +
                      "\n    "
                  ),
                ]
              : _vm._e(),
          ]
        : [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("checkout.personalisation.visitorSurvey.error")) +
                "\n  "
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }